import { render } from "./AlertCreate.vue?vue&type=template&id=b0f39370&scoped=true"
import script from "./AlertCreate.vue?vue&type=script&lang=js"
export * from "./AlertCreate.vue?vue&type=script&lang=js"

import "./AlertCreate.vue?vue&type=style&index=0&id=b0f39370&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0f39370"]])

export default __exports__